const LOG_PREFIX = '[scan-exchange]';

type ScanExchangeDebugPayload = Record<string, unknown>;

export function summarizeExchangeForm(form: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  companyName: string;
  jobTitle: string;
  message: string;
}) {
  return {
    firstNameLen: form.firstName.trim().length,
    lastNameLen: form.lastName.trim().length,
    emailLen: form.email.trim().length,
    phoneLen: form.phone.trim().length,
    companyNameLen: form.companyName.trim().length,
    jobTitleLen: form.jobTitle.trim().length,
    messageLen: form.message.trim().length,
  };
}

export function scanExchangeDebug(
  step: string,
  payload?: ScanExchangeDebugPayload,
): void {
  if (payload === undefined) {
    console.log(LOG_PREFIX, step);
    return;
  }
  console.log(LOG_PREFIX, step, payload);
}
